// extracted by mini-css-extract-plugin
export default {"caption":"ModelResponseFormat-module__caption__ZvrDRfC"};